import { Flex } from '@instamenu/ui-system-next';
import { FileText, X } from 'lucide-react';
import type { AttachmentInput } from '../thread/attachment-utils';
import * as styles from './chat-attachments.css';
import clsx from 'clsx';

export type ChatAttachmentsProps = {
  attachments: AttachmentInput[];
  onRemove: (index: number) => void;
};

export function ChatAttachments({ attachments, onRemove }: ChatAttachmentsProps) {
  if (attachments.length === 0) return null;

  return (
    <div className={styles.attachmentsContainerStyle}>
      <Flex className={styles.attachmentsScrollerStyle}>
        {attachments.map((attachment, index) => {
          const isImage = attachment.mimeType?.startsWith('image/');
          return (
            <div
              key={index}
              className={clsx(
                styles.attachmentItemStyle,
                isImage ? styles.attachmentItemVariants.image : styles.attachmentItemVariants.file,
              )}
            >
              {isImage ? (
                <img src={attachment.data} alt="Captured" className={styles.attachmentImageStyle} />
              ) : (
                <div className={styles.filePreviewStyle}>
                  <FileText size={16} />
                  <span className={styles.fileNameStyle}>{attachment.name ?? 'attachment'}</span>
                </div>
              )}
              <div className={styles.removeAttachmentStyle} onClick={() => onRemove(index)}>
                <X color="#FFF" size={10} />
              </div>
            </div>
          );
        })}
      </Flex>
    </div>
  );
}
